import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';

import { url } from "../Constent/Constant";

const GetSupport = ({ Data, UpdateImage, UpdateText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [UpdateId, setUpdateId] = useState('')

    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setUpdateId(id)
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: UpdateId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: UpdateId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if (event.key === 'Enter') {
            console.log('Enter Clicked')
            a.concat('\n')
            setHeadingUpdate(a)
        } else {
            console.log(event.key)
        }
    }


    return (
        <div className='Support-Conatiner'>
            <div className='Support-Info'>
                <h4 className='SubHeading'>{Data ? Data.section5subheading1.content : 'No Text'}
                    <i onClick={() => ShowTextModal(Data.section5subheading1._id)} className="far fa-edit Edit-btn"></i>
                </h4>
                <h2 className='Heading'> {Data ? Data.section5heading1.content : 'No Text'}
                    <i onClick={() => ShowTextModal(Data.section5heading1._id)} className="far fa-edit Edit-btn"></i>
                </h2>
                <div className='Support-Card'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(Data.section5image1._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${Data.section5image1.image}`} alt='Icon' draggable={false} />
                    </div>
                    <h3>{Data ? Data.section5heading2.content : 'No Text'}
                        <i onClick={() => ShowTextModal(Data.section5heading2._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(Data.section5paragraph1._id)} className="far fa-edit Edit-btn"></i>
                        <p>{Data ? Data.section5paragraph1.content : 'No Text'}</p>
                    </div>
                </div>
                <button className='Primary-btn Button'>GET SUPPORT</button>

            </div>
            <div className='Support-Image'>
            <i onClick={() => showImageModal(Data.section5image2._id)} className="far fa-edit Edit-btn"></i>
                <img src={`${url}/api/getFile${Data.section5image2.image}`} alt='Img' draggable={false} />
            </div>


            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>


        </div>
    )
}

export default GetSupport
